import React from "react";
import login from "../css/login.css";

const Login = () => {
  return (
    <div style={login} className="login">
      <div className="signup-container">
        <h1>Sign Up</h1>
        <div className="signup-field">
          <input type="text" placeholder="Enter your name" />
          <input type="email" placeholder="Enter your email" />
          <input type="password" placeholder="Enter your password" />
        </div>
        <div className="signup-agree">
          <input type="checkbox" name="" id="" />
          <p>By continuing, I agree to the terms of use & privacy policy </p>
        </div>
        <button>Continue</button>
        <p className="signup-login">
          Already have an account? &nbsp; <span>Login</span>
        </p>
      </div>
    </div>
  );
};

export default Login;
